import React from 'react';

const Services = (props) => {

  return(
    <div>
      <p className="services">
        Hair: long-texturing
        Color:
        Haistyles:
        Cutting:
        Extentions:
        Texture:

      </p>
      <p>
        Make-up: Glam, Special Events,
      </p>
      <p>
        Special occasions: Prices Upon Request: Weddings, Quinceneras, Pinup styles, special-effect make-up

      </p>
      <p>
        Intuitive Counselor
      </p>
    </div>
  );
};

export default Services;



// WEBPACK FOOTER //
// ./src/services.js